// Function to initialize the Service Worker
export const initServiceWorker = async () => {
  if ('serviceWorker' in navigator) {
    try {
      const registration = await navigator.serviceWorker.register(
        '/firebase-messaging-sw.js',
        {
          scope: '/',
        },
      );
      return registration;
    } catch (error) {
      console.error('Service Worker registration failed:', error);
      return null;
    }
  }
  return null;
};

// Function to request notification token
export const requestNotificationToken = async (
  vapidKey: string,
  messaging: any,
) => {
  try {
    if (!('serviceWorker' in navigator)) return null;

    const registration = await initServiceWorker();

    // Ensure service worker registration is successful
    if (!registration) {
      console.error('Service Worker registration failed');
      return null;
    }

    const permission = await Notification.requestPermission();
    if (permission !== 'granted') return null;

    // Request the notification token
    const token = await messaging.getToken({
      vapidKey: vapidKey,
      serviceWorkerRegistration: registration,
    });
    return token;
  } catch (error) {
    console.error('Error requesting notification token:', error);
    return null;
  }
};
